import { render, staticRenderFns } from "./index.vue?vue&type=template&id=80c0ba76&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c0ba76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80c0ba76')) {
      api.createRecord('80c0ba76', component.options)
    } else {
      api.reload('80c0ba76', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=80c0ba76&scoped=true&", function () {
      api.rerender('80c0ba76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_sb/uprox_status/index.vue"
export default component.exports